import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UnityDirectStateService } from '@app/core/services/unity-direct-state.service';

export const adminGuard: CanActivateFn = () => {
  const udStateService = inject(UnityDirectStateService);
  const router = inject(Router);

  const isAuthorized =
    udStateService.isAdminUser &&
    udStateService.canUserAccessAndModifyAdminClientApp;

  if (isAuthorized) {
    return true;
  }

  return router.createUrlTree(['/']);
};
